import { render, staticRenderFns } from "./Curriculo_Experiencia.vue?vue&type=template&id=12808419&scoped=true"
import script from "./Curriculo_Experiencia.vue?vue&type=script&lang=js"
export * from "./Curriculo_Experiencia.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Curriculo_Experiencia.vue?vue&type=style&index=1&id=12808419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12808419",
  null
  
)

export default component.exports